/**
 * See "P2PE eVo Terminals Implementation Guide v2.3 - May 2016.pdf" page 62.
 *
 * @type {{string: {id: number, message: string, customerFacingMessage?:string, icon?:string, actions?:string[]}}}}
 */
const Statuses = {
    PROCESSING_TRANSACTION: {
        id: 0,
        message: 'Processing Transaction',
    },
    WAITING_FOR_GRATUITY: {
        id: 1,
        message: 'Waiting For Gratuity',
        customerFacingMessage: 'Enter Gratuity',
        icon: 'pause',
    },
    GRATUITY_BEING_ENTERED: {
        id: 2,
        message: 'Gratuity Being Entered',
        icon: 'pause',
    },
    AWAITING_CARD: {
        id: 3,
        message: 'Awaiting Card',
        customerFacingMessage: 'Insert / Present Card',
        icon: 'pause',
    },
    SWIPE_CARD: {
        id: 4,
        message: 'Swipe Card',
        customerFacingMessage: 'Swipe Card',
        icon: 'pause',
    },
    CARD_INSERTED: {
        id: 5,
        message: 'Card Inserted',
        customerFacingMessage: 'Please Wait',
    },
    CARD_REMOVED: {
        id: 6,
        message: 'Card Removed',
        customerFacingMessage: 'Please Wait',
    },
    CARD_PROCESSING: {
        id: 7,
        message: 'Card Processing',
        customerFacingMessage: 'Do Not Remove Card',
    },
    CHANGE_CARD: {
        id: 8,
        message: 'Change Card',
        customerFacingMessage: 'Use Alternative Payment Method',
    },
    CONTACT_TRANSACTION_REQUIRED: {
        id: 9,
        message: 'Contact Transaction Required',
    },
    KEY_IN_CARD_DETAILS: {
        id: 10,
        message: 'Key In Card Details',
        customerFacingMessage: 'Key Card Number',
        icon: 'hand-up',
    },
    WAITING_FOR_CASHBACK: {
        id: 11,
        message: 'Waiting For Cashback',
        customerFacingMessage: 'Enter Cashback',
        icon: 'pause',
    },
    PIN_ENTRY: {
        id: 12,
        message: 'Pin Entry',
        customerFacingMessage: 'Enter PIN',
        icon: 'pause',
    },
    RISK_MANAGEMENT_COMPLETE: {
        id: 13,
        message: 'Risk Management Complete',
    },
    AUTHORISING_TRANSACTION: {
        id: 14,
        message: 'Authorising Transaction',
        customerFacingMessage: 'Please Wait',
    },
    WAITING_FOR_RESULT: {
        id: 15,
        message: 'Waiting For Result',
        customerFacingMessage: 'Please Wait',
    },
    AUTH_RESULT_RECEIVED: {
        id: 16,
        message: 'Auth Result Received',
        customerFacingMessage: 'Please Wait',
    },
    PRINTING_MERCHANT_RECEIPT: {
        id: 17,
        message: 'Printing Merchant Receipt',
        customerFacingMessage: 'Please Wait',
        icon: 'print',
    },
    SIGNATURE_CONFIRMATION_REQUIRED: {
        id: 18,
        message: 'Signature Confirmation Required',
        customerFacingMessage: 'Please Wait',
        icon: 'pencil',
    },
    CONTINUE_REQUIRED: {
        id: 19,
        message: 'Continue Required',
        icon: 'pause',
    },
    CONFIRM_AUTH_CODE: {
        id: 20,
        message: 'Confirm Auth Code',
        icon: 'question-sign',
    },
    CONFIRMING_TRANSACTION: {
        id: 21,
        message: 'Confirming Transaction',
        customerFacingMessage: 'Please Wait',
    },
    REJECTING_TRANSACTION: {
        id: 22,
        message: 'Rejecting Transaction',
        customerFacingMessage: 'Declined',
    },
    FINAL_RESULT_RECEIVED: {
        id: 23,
        message: 'Final Result Received',
        customerFacingMessage: 'Please Wait',
    },
    VOICE_REFERRAL: {
        id: 24,
        message: 'Voice Referral',
        customerFacingMessage: 'Referral',
    },
    REMOVE_CARD: {
        id: 25,
        message: 'Remove Card',
        customerFacingMessage: 'Remove Card',
        icon: 'eject',
    },
    AUTH_RESULT_ERROR: {
        id: 26,
        message: 'Auth Result Error',
    },
    FALLBACK_TO_SWIPE_DISABLED: {
        id: 27,
        message: 'Fallback To Swipe Disabled',
    },
    DOWNLOADING_FILE: {
        id: 28,
        message: 'Downloading File',
        customerFacingMessage: 'Loading',
    },
    UPDATING_PED: {
        id: 29,
        message: 'Updating PED',
        customerFacingMessage: 'Loading',
    },
    INVALID_PED_CONFIGURATION: {
        id: 30,
        message: 'Invalid PED Configuration',
    },
    CARD_DATA_RETRIEVAL: {
        id: 31,
        message: 'Card Data Retrieval',
    },
    STARTING_TRANSACTION: {
        id: 32,
        message: 'Starting Transaction',
        customerFacingMessage: 'Please Wait',
    },
    PERFORMING_DOWNLOAD: {
        id: 33,
        message: 'Performing Download',
        customerFacingMessage: 'Loading',
    },
    REQUESTING_REPORT: {
        id: 34,
        message: 'Requesting Report',
        customerFacingMessage: 'Please Wait',
    },
    GRATUITY_SELECTION_REQUIRED: {
        id: 35,
        message: 'Gratuity Selection Required',
        icon: 'hand-up',
    },
    EXPIRY_DATE_REQUIRED: {
        id: 36,
        message: 'Expiry Date Required',
        customerFacingMessage: 'Expires MM/YY',
        icon: 'hand-up',
    },
    START_DATE_REQUIRED: {
        id: 37,
        message: 'Start Date Required',
        customerFacingMessage: 'Valid From MM/YY',
        icon: 'hand-up',
    },
    ISSUE_NUMBER_REQUIRED: {
        id: 38,
        message: 'Issue Number Required',
        customerFacingMessage: 'Issue Number',
        icon: 'hand-up',
    },
    AVS_HOUSE_NUMBER_REQUIRED: {
        id: 39,
        message: 'AVS House Number Required',
        customerFacingMessage: 'Enter House Number',
        icon: 'hand-up',
    },
    AVS_POST_CODE_REQUIRED: {
        id: 40,
        message: 'AVS Post Code Required',
        customerFacingMessage: 'Enter Post Code',
        icon: 'hand-up',
    },
    CSC_REQUIRED: {
        id: 41,
        message: 'CSC Required',
        customerFacingMessage: 'Enter Card Security Code',
        icon: 'hand-up',
    },
    CUSTOMER_PRESENT_NOT_PRESENT_SELECTION_REQUIRED: {
        id: 42,
        message: 'Customer Present / Not Present Selection Required',
        customerFacingMessage: 'Customer Present? Yes/No',
        icon: 'hand-up',
    },
    CUSTOMER_NOT_PRESENT_OPTION_SELECTION_REQUIRED: {
        id: 43,
        message: 'Customer / Not Present Option Selection Required',
        customerFacingMessage: 'hand-up',
    },
    ENTER_CHARGE_AUTH_CODE: {
        id: 44,
        message: 'Enter Charge Auth Code',
        customerFacingMessage: 'Enter Charge Auth Code',
        icon: 'hand-up',
    },
    LOGIN_REQUIRED: {
        id: 45,
        message: 'Login Required',
        icon: 'warning-sign',
    },
    READY: {
        id: 46,
        message: 'Ready',
        customerFacingMessage: 'Ready',
        icon: 'ok-circle',
    },
    CARD_NOT_ACCEPTED: {
        id: 47,
        message: 'Card Not Accepted',
        customerFacingMessage: 'Not Accepted',
    },
    CARD_BLOCKED: {
        id: 48,
        message: 'Card Blocked',
    },
    TRANSACTION_CANCELLED: {
        id: 49,
        message: 'Transaction Cancelled',
        customerFacingMessage: 'Transaction Void',
    },
    INVALID_EXPIRY: {
        id: 50,
        message: 'Invalid Expiry',
    },
    GRATUITY_INVALID: {
        id: 51,
        message: 'Gratuity Invalid',
    },
    INVALID_CARD: {
        id: 52,
        message: 'Invalid Card',
    },
    PRINTING_CUSTOMER_RECEIPT: {
        id: 53,
        message: 'Printing Customer Receipt',
        customerFacingMessage: 'Please Wait',
        icon: 'print',
    },
    INITIALISING_PED: {
        id: 54,
        message: 'Initialising PED',
        customerFacingMessage: 'Please Wait',
    },
    PED_UNAVAILABLE: {
        id: 55,
        message: 'PED Unavailable',
        icon: 'warning-sign',
    },
    CARD_APPLICATION_SELECTION: {
        id: 56,
        message: 'Card Application Selection',
        customerFacingMessage: 'Select Payment Type',
    },
    RETRY_DOWNLOAD: {
        id: 57,
        message: 'Retry Download',
    },
    RESTART_AFTER_SOFTWARE_UPDATE: {
        id: 58,
        message: 'Restart After Software Update',
    },
    REQUESTING_DCC: {
        id: 59,
        message: 'Requesting DCC',
        customerFacingMessage: 'Please Wait',
    },
    DCC_CURRENCY_CHOICE: {
        id: 60,
        message: 'DCC Currency Choice',
    },
    CARDHOLDER_DCC_CURRENCY_CHOICE: {
        id: 61,
        message: 'Cardholder DCC Currency Choice',
        customerFacingMessage: 'Please select currency',
    },
    UNSAFE_DOWNLOAD: {
        id: 62,
        message: 'Unsafe Download',
    },
    UNEXPECTED_LOGIN: {
        id: 63,
        message: 'Unexpected Login',
    },
    START_BARCLAYS_BONUS_TRANSACTION: {
        id: 64,
        message: 'Start Barclays Bonus Transaction',
    },
    UPDATE_BARCLAYS_BONUS_TRANSACTION: {
        id: 65,
        message: 'Update Barclays Bonus Transaction',
    },
    CANCEL_BARCLAYS_BONUS_TRANSACTION: {
        id: 66,
        message: 'Cancel Barclays Bonus Transaction',
    },
    CONFIRM_GRATUITY: {
        id: 67,
        message: 'Confirm Gratuity',
    },
    REGISTER_FOR_ACCOUNT_ON_FILE_DECISION: {
        id: 68,
        message: 'Register For Account On File Decision',
    },
    AWAITING_TOKEN_ID: {
        id: 69,
        message: 'Awaiting Token ID',
    },
    BARCLAYS_BONUS_DISCOUNT_SUMMARY: {
        id: 70,
        message: 'Barclays Bonus Discount Summary',
    },
    BARCLAYS_BONUS_USE_BONUS: {
        id: 71,
        message: 'Barclays Bonus Use Bonus',
    },
    BARCLAYS_BONUS_ENTER_REDEMPTION: {
        id: 72,
        message: 'Barclays Bonus Enter Redemption',
    },
    BARCLAYS_BONUS_NOT_AVAILABLE: {
        id: 73,
        message: 'Barclays Bonus Not Available',
    },
    DOWNLOAD_COMPLETE: {
        id: 74,
        message: 'Download Complete',
    },
    DOWNLOAD_STILL_BEING_PREPARED: {
        id: 75,
        message: 'Download Still Being Prepared',
    },
    SERVER_CONNECTION_FAILED: {
        id: 76,
        message: 'Server Connection Failed',
    },
    RESUME_DOWNLOAD: {
        id: 77,
        message: 'Resume Download',
    },
    REPRINT_COMPLETE: {
        id: 78,
        message: 'Reprint Complete',
    },
};

module.exports = Statuses;
